const isNull = (value) => {
  if (Array.isArray(value)) {
    if (value.length === 0) {
      return '不可为空'
    } else {
      return null
    }
  } else {
    return value.toString() ? null : '不可为空'
  }
}
const isNumber = (value) => {
  if (typeof value === 'number' && !Number.isNaN(value)) {
    return null
  } else {
    return '请输入正确的数字'
  }
}

const isGtZero = (value) => {
  if (typeof value === 'number' && !Number.isNaN(value)) {
    if (value > 0) {
      return null
    } else {
      return '请输入正确的数字'
    }
  } else {
    return '请输入正确的数字'
  }
}

export {
  isNull, isGtZero, isNumber
}
